import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import theme from 'site-react/theme';

import MobileNavList from './MobileNavList';
import MobileNavMenuListItem from './MobileNavMenuListItem';
import MobileNavMenuSingleLink from './MobileNavMenuSingleLink';
import MobileNavMenuMultipleLinks from './MobileNavMenuMultipleLinks';

const listItemStyle = css`
  margin: 0;
`;

const moreLinkStyle = css`
  color: ${theme.colors.brandPrimary};
  font-weight: ${theme.font.weight.medium};
  font-size: ${theme.font.size.xs};
`;

const MobileNavMenu = ({ links, onNavListItemClick }) => (
  <MobileNavList>
    {links.map((section) => (
      <li className={listItemStyle} key={section.title}>
        {section.links.length === 1 && section.title !== 'Cities' ? (
          <MobileNavMenuSingleLink
            link={section.links[0]}
            analytics={section.analytics}
            onNavListItemClick={onNavListItemClick}
          />
        ) : (
          <MobileNavMenuMultipleLinks
            title={section.title}
            analytics={section.analytics}
            links={section.links}
            onNavListItemClick={onNavListItemClick}
          />
        )}

        {section.more && (
          <ul>
            <MobileNavMenuListItem
              className={moreLinkStyle}
              {...section.more}
              clickHandler={(e) => onNavListItemClick(e, section.more)}
            />
          </ul>
        )}
      </li>
    ))}
  </MobileNavList>
);

MobileNavMenu.defaultProps = {
  onNavListItemClick: null,
  links: [
    {
      loggedIn: false,
      analytics: {},
    },
  ],
};

MobileNavMenu.propTypes = {
  onNavListItemClick: PropTypes.func,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      loggedIn: PropTypes.bool,
      title: PropTypes.string.isRequired,
      links: PropTypes.array.isRequired,
      more: PropTypes.object,
      analytics: PropTypes.object,
    }),
  ),
};

export default MobileNavMenu;
